import selectDropDownIcon from "assets/images/select-dropdown-icon.svg";
import classNames from "classnames";

import styles from "./Select.module.css";

type SelectTypes = string | number;

type Props<T extends SelectTypes> = {
  className?: string;
  selectClassName?: string;
  optionClassName?: string;
  options: Array<{
    label: string;
    value: T;
  }>;
  value: T;
  placeholder?: string;
  onChange: (value: T) => void;
  disabled?: boolean;
};

export default function Select<T extends SelectTypes>(props: Props<T>) {
  return (
    <div className={classNames(styles.selectContainer, props.className)}>
      <select
        className={classNames(styles.select, props.selectClassName)}
        value={props.value}
        onChange={(e) => props.onChange(e.target.value as T)}
        disabled={props.disabled}
      >
        {props.placeholder ? (
          <option value="" disabled>
            {props.placeholder}
          </option>
        ) : null}
        {props.options.map((option) => (
          <option
            className={props.optionClassName}
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
      {props.disabled ? null : <img src={selectDropDownIcon} alt="" />}
    </div>
  );
}
